var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"crown-button",attrs:{"id":_vm.id,"aria-label":_vm.ariaLabel}},_vm.$listeners),[_vm._t("default",function(){return [_c('img',{staticClass:"crown-icon",attrs:{"src":_vm.src,"width":"width","height":"height"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }